import React from "react";
import {
  InlineButtonIconPropsModel,
  InlineButtonIconTypeModel,
} from "./InlineButton.types";
import { Icon } from "../Icon/Icon";
import { ReactComponent as ChevronRightIcon } from "common-assets/assets/icons/chevron-right.svg";
import { ReactComponent as ChevronLeftIcon } from "common-assets/assets/icons/chevron-left.svg";
import { ReactComponent as ChevronDownIcon } from "common-assets/assets/icons/chevron-down.svg";
import { ReactComponent as ChevronUpIcon } from "common-assets/assets/icons/chevron-up.svg";
import clsx from 'clsx';

const iconMap: Record<InlineButtonIconTypeModel, React.ReactNode> = {
  chevronRight: <ChevronRightIcon />,
  chevronLeft: <ChevronLeftIcon />,
  chevronDown: <ChevronDownIcon />,
  chevronUp: <ChevronUpIcon />,
};

export const InlineButtonIcon = ({
  iconType,
  customIcon,
  className,
}: InlineButtonIconPropsModel) => {
  if (customIcon) {
    return <Icon className={clsx(className, 'InlineButton-customIcon')}>{customIcon}</Icon>;
  }
  if (iconType) {
    return <Icon className={clsx(className, `InlineButton-icon-${iconType}`)}>{iconMap[iconType]}</Icon>;
  }
  return null;
};
